import { render } from "./StaffAttendanceManagement.vue?vue&type=template&id=589dc460&scoped=true&ts=true"
import script from "./StaffAttendanceManagement.vue?vue&type=script&lang=ts"
export * from "./StaffAttendanceManagement.vue?vue&type=script&lang=ts"

import "./StaffAttendanceManagement.vue?vue&type=style&index=0&id=589dc460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589dc460"]])

export default __exports__